import { apiUri } from '@/constants/Constants';
import { modernClient } from '@/utils/axios/axiosClient';
import type { Address, AddressesResponse } from '@/utils/types/address.interface';

const DEFAULT_LIMIT = 500;

export interface GetAddressesParams {
  page?: number;
  limit?: number;
  search?: string;
}

const getAddresses = async ({
  page = 1,
  limit = DEFAULT_LIMIT,
  search,
}: GetAddressesParams = {}): Promise<Address[]> => {
  const response = await modernClient.get<AddressesResponse>(apiUri.addressesList, {
    params: {
      page,
      limit,
      ...(search && { search }),
    },
  });

  return response.data.addresses;
};

export default getAddresses;
